// version 01/12
var rootlinkTwitterPixel = "https://apps3.omegatheme.com/twitter-multi-pixels";
// var rootlinkTwitterPixel = "https://dev.twoowls.io/twitter-multi-pixels"; // dev
// var rootlinkTwitterPixel = "http://localhost:8000/twitter-multi-pixels";
shop = Shopify.shop;
var pageURL = window.location.href;
var currency = Shopify.currency.active;
var cart_url = "//" + window.location.hostname + "/cart.json";
var itemInCart;
var otElementButtonAddToCartTwitter =
  "#teeAtcButton,#new-form-atc,.ProductForm__AddToCart, .product-form__add-button,.single_add_to_cart_button,#AddToCartForm button,.product__form button.add-to-cart, #AddToCart-product-template,.product-form__cart-submit,[name^='add']";
var otElementButtonCheckoutTwitter =
  'form[action^="/checkout"] :submit[name^="checkout"],form[action^="/checkout"] .checkout-button,.checkout_btn,.OTCheckout,[name^="checkout"],form[action^="/cart"] :submit[name^="checkout"],form[action^="/cart"] .checkout-button,#cart .action_button.right, #mu-checkout-button, .upcart-checkout-button';
window.arrayCheck = [];
window.ot_email = "";
if (localStorage.getItem("ot_email") !== null)
  window.ot_email = localStorage.getItem("ot_email");
//twitter app create by Huy 08/03/2021
!(function (e, t, n, s, u, a) {
  e.ottwitter = function () {
    e.twq ||
      ((s = e.twq =
        function () {
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        }),
      (s.version = "1.1.0"),
      (s.queue = []),
      (u = t.createElement(n)),
      (u.async = !0),
      (u.src = "//static.ads-twitter.com/uwt.js"),
      (a = t.getElementsByTagName(n)[0]),
      a.parentNode.insertBefore(u, a));
    if (arguments.length > 0) {
      var g, p, c;
      "string" == typeof arguments[0] && (g = arguments[0]),
        "string" == typeof arguments[1] && (p = arguments[1]),
        "object" == typeof arguments[2] ? (c = arguments[2]) : (c = {});
      if (
        "string" == typeof g &&
        "" != g.replace(/\s+/gi, "") &&
        "string" == typeof p &&
        p.replace(/\s+/gi, "")
      ) {
        // twq("init", g);
        switch (p) {
          case "Base":
            twq("config", g);
            break;
          case "AddToCart":
            twq("event", g, c);
            break;
          case "InitiateCheckout":
            twq("event", g, c);
            break;
          case "PageView":
          case "ViewContent":
          case "Search":
          case "AddPaymentInfo":
          case "Lead":
          case "CompleteRegistration":
          case "Purchase":
          case "AddToWishlist":
            setTimeout(() => {
              twq("event", g, { email_address: window.ot_email, ...c });
            }, 1000);
            break;
          default:
            return;
        }
      }
    }
  };
})(window, document, "script");

if (typeof $ == "undefined") {
  javascript: (function (e, s) {
    e.src = s;
    e.onload = function () {
      $ = jQuery.noConflict();
      if (typeof window.otCheckExistFileTwitter === "undefined") {
        otTwitterPixelInit($);
        window.otCheckExistFileTwitter = false;
      }
    };
    document.head.appendChild(e);
  })(
    document.createElement("script"),
    "https://cdn.shopify.com/s/files/1/0559/8792/9227/files/jquery-3.6.3.min.js"
  );
} else {
  if (typeof window.otCheckExistFileTwitter === "undefined") {
    otTwitterPixelInit($);
    window.otCheckExistFileTwitter = false;
  }
}

async function otTwitterPixelInit($) {
  if (localStorage.getItem("ot_email") == null) {
    var email = await sha256("");
    window.ot_email = email;
    localStorage.setItem("ot_email", email);
  }
  let checkExpireApp = await ottwitterPixelCheckExpireApp(
    $,
    rootlinkTwitterPixel,
    shop
  );
  if (checkExpireApp.checkExpire == false && checkExpireApp.enableApp == "1") {
    otMultiTwitterPixel($);
  }
}

async function otMultiTwitterPixel($) {
  if (
    typeof arrayTwitterPixelTrack != "undefined" &&
    arrayTwitterPixelTrack.length > 0
  ) {
    otGetBasePixel(arrayTwitterPixelTrack);
    getArrayPixelForEvent("Page view (formerly site visit)").forEach(function (
      element,
      index
    ) {
      ottwitter(`${element}`, "PageView");
    });
    if (pageURL.indexOf("/products/") > -1) {
      // add event ViewContent
      if (pageURL.indexOf("?") > -1) {
        var product_url = pageURL.split("?");
        product_url = product_url[0] + ".json";
      } else {
        var product_url = pageURL + ".json";
      }
      var product = await otGetInfoProductByLinkTwitter(product_url, $);
      if (product.title.indexOf("'") > -1) {
        product.title = product.title.replace(/'/g, "");
      }
      getArrayPixelForEvent("Content view").forEach(function (element, index) {
        ottwitter(`${element}`, "ViewContent", {
          value: product.variants[0].price,
          currency: currency,
          contents: [
            {
              content_id: product.id,
              content_type: "product",
              content_name: product.title,
              content_price: product.variants[0].price,
              num_items: 1,
              content_group_id: product.variants[0].id,
            },
          ],
        });
      });
    }
    if (pageURL.indexOf("/cart") > -1) {
      getItemOnCartPage($, function (cart) {
        itemInCart = cart;
        let items = cart.items;
        let lastItem = items[items.length - 1];
        let totalItemCart = localStorage.getItem("OTPXTWITTER");
        let checkAddedOnProductPage = localStorage.getItem("OTPXTWITTERADDED");
        let contents = [
          {
            content_id: lastItem["product_id"],
            content_type: "product",
            content_name: lastItem["product_title"],
            content_price: parseInt(lastItem["price"]) / 100,
            num_items: lastItem["quantity"],
            content_group_id: lastItem["product_id"],
          },
        ];
        if (
          (totalItemCart != cart.item_count || totalItemCart == null) &&
          checkAddedOnProductPage != 1
        ) {
          localStorage.setItem("OTPXTWITTERADDED", 0);
          localStorage.setItem("OTPXTWITTER", cart.item_count);
          getArrayPixelForEvent("Add to cart").forEach(function (
            element,
            index
          ) {
            ottwitter(`${element}`, "AddToCart", {
              value: parseInt(cart.total_price) / 100,
              currency: currency,
              contents: contents,
            });
          });
        }
      });
    }
    // add event AddToCart
    $(otElementButtonAddToCartTwitter).click(function (e) {
      $.ajax({
        type: "GET",
        url: "/cart.js",
        dataType: "json",
      }).done((cart) => {
        localStorage.setItem("OTPXTWITTERADDED", 1);
        if (cart.items.length > 0) {
          let lastItem = cart.items[0];
          let items = cart.items;
          let contents = [
            {
              content_id: lastItem["product_id"],
              content_type: "product",
              content_name: lastItem["product_title"],
              content_price: parseInt(lastItem["price"]) / 100,
              num_items: lastItem["quantity"],
              content_group_id: lastItem["product_id"],
            },
          ];
          getArrayPixelForEvent("Add to cart").forEach(function (
            element,
            index
          ) {
            ottwitter(`${element}`, "AddToCart", {
              value: parseInt(cart.total_price) / 100,
              currency: currency,
              contents: contents,
            });
          });
        } else {
          if (
            typeof __st.rid != "undefined" &&
            typeof meta.product.variants[0]["id"] != "undefined"
          ) {
            getArrayPixelForEvent("Add to cart").forEach(function (
              element,
              index
            ) {
              //titok
              ottwitter(`${element}`, "AddToCart", {
                value: parseInt(meta.product.variants[0]["price"]) / 100,
                currency: currency,
                contents: [
                  {
                    content_id: __st.rid,
                    content_type: "product",
                    content_name: meta.product.variants[0]["name"],
                    content_price:
                      parseInt(meta.product.variants[0]["price"]) / 100,
                    num_items: 1,
                    content_group_id: __st.rid,
                  },
                ],
              });
            });
          } else {
            setTimeout(() => {
              omegaTwitterCallbackAtc();
            }, 1000);
          }
        }
      });
    });

    // add event InitiateCheckout
    $("body").on("click", otElementButtonCheckoutTwitter, function (e) {
      if (
        typeof itemInCart != "undefined" &&
        typeof itemInCart.items != "undefined"
      ) {
        var cart = itemInCart;
        if (cart.items.length > 0) {
          let items = cart.items;
          let content = [];
          items.forEach((e) => {
            content.push({
              content_id: e["product_id"],
              content_type: "product",
              content_name: e["product_title"],
              content_price: parseInt(e["price"]) / 100,
              num_items: e["quantity"],
              content_group_id: e["product_id"],
            });
          });
          getArrayPixelForEvent("Checkout Initiated").forEach(function (
            element,
            index
          ) {
            ottwitter(`${element}`, "InitiateCheckout", {
              value: parseInt(cart.total_price) / 100,
              currency: currency,
              contents: content,
            });
          });
        }
      } else {
        $.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
        })
          .done((cart) => {
            if (cart.items.length > 0) {
              let items = cart.items;
              let content = [];
              items.forEach((e) => {
                content.push({
                  content_id: e["product_id"],
                  content_type: "product",
                  content_name: e["product_title"],
                  content_price: parseInt(e["price"]) / 100,
                  num_items: e["quantity"],
                  content_group_id: e["product_id"],
                });
              });
              getArrayPixelForEvent("Checkout Initiated").forEach(function (
                element,
                index
              ) {
                ottwitter(`${element}`, "InitiateCheckout", {
                  value: parseInt(cart.total_price) / 100,
                  currency: currency,
                  contents: content,
                });
              });
            }
          })
          .fail(function (jqXHR, textStatus) {});
      }
    });
  }
  if (Shopify.Checkout && Shopify.Checkout.page.includes("thank_you")) {
    var contents = [];
    var quantity = 0;
    Shopify.checkout.line_items.forEach(function (item, index) {
      quantity = quantity + item.quantity;
      if (item.variant_title != "") {
        var prod_name = item.title + " - " + item.variant_title;
      } else {
        var prod_name = item.title;
      }
      contents.push({
        content_id: `${item.product_id}`,
        content_name: prod_name,
        content_price: item.price,
        num_items: quantity,
        content_type: "product_group",
      });
    });

    addEventPurchaseInThankYouPageTwitter($, contents);
  }
}

function otGetBasePixel(pixels) {
  let listBasePixel = [];
  pixels.forEach((pixel) => {
    pixel.split("-")[1] != undefined && listBasePixel.push(pixel.split("-")[1]);
  });
  listBasePixel = [...new Set(listBasePixel)];
  listBasePixel.forEach((base) => {
    ottwitter(`${base}`, "Base", {});
  });
}

function omegaTwitterCallbackAtc() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
  }).done((cart) => {
    localStorage.setItem("OTPXTWITTERADDED", 1);
    if (cart.items.length > 0) {
      let lastItem = cart.items[0];
      let items = cart.items;
      let contents = [
        {
          content_id: lastItem["product_id"],
          content_type: "product",
          content_name: lastItem["product_title"],
          content_price: parseInt(lastItem["price"]) / 100,
          num_items: lastItem["quantity"],
          content_group_id: lastItem["product_id"],
        },
      ];
      getArrayPixelForEvent("Add to cart").forEach(function (element, index) {
        ottwitter(`${element}`, "AddToCart", {
          value: parseInt(cart.total_price) / 100,
          currency: currency,
          contents: contents,
        });
      });
    }
  });
}

function getItemOnCartPage($, callback) {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    dataType: "json",
  }).done((cart) => {
    if (typeof callback == "function") {
      callback(cart);
    }
  });
}

function getArrayPixelForEvent(
  event,
  arrAllPixel = arrayTwitterPixelTrack,
  list = listTwitterPixelByType
) {
  let arrTrack = [];
  if (list[event] != undefined) {
    arrAllPixel.forEach((e) => list[event].includes(e) && arrTrack.push(e));
  }
  return arrTrack;
}

function isUSePixelFromShopifyTwitter() {
  if (typeof trekkie.integrations[2].options.pixelIds != "undefined") {
    $.ajax({
      type: "GET",
      data: { action: "checkUsePixelFromShopifyTwitter", shop: shop },
      url: `${rootlinkTwitterPixel}/client/twitter-pixel.php`,
      dataType: "json",
    }).done((result) => {});
  }
}
function ottwitterPixelCheckExpireApp($, rootlinkTwitterPixel, shop) {
  "use strict";
  return new Promise((resolve) => {
    $.ajax({
      type: "GET",
      data: { action: "checkExpire", shop: shop },
      url: `${rootlinkTwitterPixel}/client/twitter-pixel.php`,
      dataType: "json",
    }).done((result) => {
      if (typeof result == "string") {
        result = JSON.parse(result);
      }
      resolve(result);
    });
  });
}
async function addEventPurchaseInThankYouPageTwitter($, contents) {
  var pixels = await otgetAllPixelTwitter($, contents);
  let arrPV =
    pixels["Page view (formerly site visit)"] != undefined
      ? pixels["Page view (formerly site visit)"]
      : [];
  let arrPur = pixels["Purchase"] != undefined ? pixels["Purchase"] : [];

  let listBasePixel = [];
  [...arrPV, ...arrPur].forEach((pixel) => {
    pixel.split("-")[1] != undefined && listBasePixel.push(pixel.split("-")[1]);
  });
  listBasePixel = [...new Set(listBasePixel)];
  listBasePixel.forEach((base) => {
    ottwitter(`${base}`, "Base", {});
  });

  var email =
    typeof Shopify.checkout.email != "undefined" ? Shopify.checkout.email : "";
  email = await sha256(email);
  localStorage.setItem("email", email);
  arrPV.forEach(function (element, index) {
    ottwitter(`${element}`, "PageView", { email_address: email });
  });
  arrPur.forEach(function (element, index) {
    ottwitter(`${element}`, "Purchase", {
      currency: currency,
      email_address: email,
      value: Number(Shopify.checkout.total_price),
      contents: contents,
    });
  });
}
function otgetAllPixelTwitter($, contents) {
  productIds = contents[0].content_id;
  return new Promise((resolve) => {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        resolve(JSON.parse(xhttp.responseText));
      }
    };
    xhttp.open(
      "GET",
      `${rootlinkTwitterPixel}/client/twitter-pixel.php?shop=${shop}&action=getAllPixel&productIds=${productIds}`,
      true
    );
    xhttp.send();
  });
}
function otGetInfoProductByLinkTwitter(URL, $) {
  return new Promise((resolve) => {
    $.ajax({
      url: URL,
      dataType: "jsonp",
      header: { "Access-Control-Allow-Origin": "*" },
      success: function (responseData) {
        if (typeof responseData == "string") {
          responseData = JSON.parse(responseData);
        }
        resolve(responseData.product);
      },
    });
  });
}

/**
 * Function to hash code type sha-256
 * @param {string} message: message to hash
 * @returns hash code
 */
async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
}
